/* eslint-disable import/prefer-default-export */
import moment from 'moment-timezone';

export const checkIfShouldSkipCurrentDay = ({
  current,
  recurringOption,
  timezone,
  firstSession,
}) => {
  const currentDay = moment(current).tz(timezone).format('ddd').toLowerCase();
  if (recurringOption === 'every-weekday') {
    return currentDay === 'sat' || currentDay === 'sun';
  }
  if (recurringOption === 'every-week') {
    const firstSessionDay = moment(firstSession).tz(timezone).format('ddd').toLowerCase();
    return currentDay !== firstSessionDay;
  }
  return false;
};
